import React from 'react'
import { useTranslation } from 'react-i18next'

import { ActionIcon } from 'components/Elements'
import { usePopup } from 'hooks'
import { CategoryEdit } from 'features/immigrate-category/components/ImmigrateCategory'

export const EditControl = ({ data, onSuccess }) => {
  const { t } = useTranslation()

  const { id } = data

  const { visible, open, close } = usePopup()

  const onSubmitSuccess = data => {
    close()

    onSuccess && onSuccess(data)
  }

  return (
    <>
      <div>
        <ActionIcon onClick={open} name={'edit'} outline={false} />
      </div>

      <CategoryEdit id={id} visible={visible} onClose={close} onSuccess={onSubmitSuccess} />
    </>
  )
}
